import { IApiError } from '@/models/apiError.model';
import { ISuggestedFaq } from '@/models/suggestedFaq.model';
import { IPagination } from '@/models/pagination.model';

export const SLICE_NAME = 'suggestedFaq';

export interface SuggestedFaqState {
  suggestions: ISuggestedFaq[] | null;
  isLoading: boolean;
  error: IApiError | null;
  pagination: IPagination | null;
}

export const initialState: SuggestedFaqState = {
  suggestions: null,
  pagination: null,
  isLoading: false,
  error: null,
};
